// extracted by mini-css-extract-plugin
export var productImage = "_oz-1";
export var viewLink = "_oz-2";
export var wishlistItem = "_oz-0";